export const BRANCH_TYPES = {
  FLAGSHIP: 'Flagship',
  STANDARD: 'Standard',
  FRANCHISE: 'Franchise',
  WAREHOUSE: 'Warehouse'
};

export const STORE_TYPES = {
  RETAIL: 'Retail',
  MALL: 'Mall',
  HIGH_STREET: 'High Street',
  COMMUNITY: 'Community',
  AIRPORT: 'Airport',
  HOTEL: 'Hotel'
};

export const RATE_POLICIES = {
  INHERIT: 'Inherit',
  CUSTOM: 'Custom',
  HYBRID: 'Hybrid'
};

export const RATE_MODES = {
  LIVE: 'Live',
  ADMIN: 'Admin',
  HYBRID: 'Hybrid'
};

export const CITY_TIERS = {
  METRO: 'Metro',
  TIER1: 'Tier 1',
  TIER2: 'Tier 2',
  TIER3: 'Tier 3',
  RURAL: 'Rural'
};

export const STATE_CODES = {
  AN: "Andaman and Nicobar Islands",
  AP: "Andhra Pradesh",
  AR: "Arunachal Pradesh",
  AS: "Assam",
  BR: "Bihar",
  CH: "Chandigarh",
  CT: "Chhattisgarh",
  DN: "Dadra and Nagar Haveli",
  DD: "Daman and Diu",
  DL: "Delhi",
  GA: "Goa",
  GJ: "Gujarat",
  HR: "Haryana",
  HP: "Himachal Pradesh",
  JK: "Jammu and Kashmir",
  JH: "Jharkhand",
  KA: "Karnataka",
  KL: "Kerala",
  LD: "Lakshadweep",
  MP: "Madhya Pradesh",
  MH: "Maharashtra",
  MN: "Manipur",
  ML: "Meghalaya",
  MZ: "Mizoram",
  NL: "Nagaland",
  OR: "Odisha",
  PY: "Puducherry",
  PB: "Punjab",
  RJ: "Rajasthan",
  SK: "Sikkim",
  TN: "Tamil Nadu",
  TG: "Telangana",
  TR: "Tripura",
  UP: "Uttar Pradesh",
  UT: "Uttarakhand",
  WB: "West Bengal"
};